<div class="headerSection">
  <div class="headerContainer">
    <div class="headerBar">


      <div class="hambugurBlock">
        <button class="hambugurBtn" (click)="showMenu()"> <img src="assets/images/hambergur.svg" alt=""> </button>
      </div>
      <div class="logoBlock">
        <a routerLink="/">
          <img class="logo" src="assets/images/her-store-logo.png" alt="Her Store" />
        </a>
      </div>
      <div class="rightMenu">
        <div class="wishListBLock d-none d-lg-block">
          <div class="wishListIcon">
            <!-- <img src="assets/images/heart.svg" alt="Wish List" /> -->
            <!-- <span class="itemCount">2</span> -->
          </div>
        </div>
        <div class="LoginBtnBlock" *ngIf='checkUserLoggedIn() else loginView'>
          <div class="LoginBtncontainer">
            <div class="sinInBtanMob d-block d-lg-none" (click)="showPopup(4,$event)">
              <img src="assets/images/user.svg" alt="" />
            </div>
            <div class="ddLinkWrap d-none d-lg-block">
              <div class="ddLink" (click)="showPopup(4,$event)">
                LOGIN
                <img src="assets/images/downArrow.svg" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="LanguageBlock d-none d-lg-block" *ngIf="languageList && languageList.length">

          <!-- <button class="langBtn" (click)="showLanguageSelection = !showLanguageSelection">ENG <img class="langarr"
              src="assets/images/langarr.svg" alt=""></button> -->

          <!-- <div class="langiconbox" *ngIf="showLanguageSelection">
            <span *ngFor="let lang of languageList">
              <img class="langIco" src="{{lang.icon_url}}" alt="" (click)="updateLanguage(lang.code)">
            </span>
          </div> -->

          <!-- <select class="langSelect" (change)="updateLanguage($event.target)">
            <option value="{{lang.code}}" *ngFor="let lang of languageList">{{lang.name}}</option>
          </select> -->
        </div>


        <!-- language translate dropdown -->
        <!-- <div *ngIf="!isMobile">
          <div id="google_translate_element" class="googleLang desk"></div>
        </div> -->

      </div>
    </div>
  </div>
  <!-- <div class="yellow-tape">

  </div> -->
</div>

<ng-template #loginView>
  <div class="LoginBtncontainer">
    <div class="sinInBtanMob d-flex d-lg-none" (click)="showPopup(4,$event)">
      <img src="assets/images/user.svg" alt="" />
    </div>
    <div class="themeBtnYellow d-none d-lg-flex" (click)="showPopup(4,$event)">
      <div class="usernnm">{{getUserName()}}</div>
      <img src="assets/images/downArrow.svg" alt="" />
    </div>
    <div *ngIf="showLogoutOptoin">
      <div class="dropdninner ">
        <!-- <a routerLink="{{language}}/personal-info">Profile </a> -->
        <a (click)="logoutUser()">Logout</a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="shimmertext">
    <span class="loader"></span>
  </div>
</ng-template>

<ng-template #loading1>
  <div class="shimmertext">
    <span class="loader"></span>
  </div>
</ng-template>
